// extracted by mini-css-extract-plugin
module.exports = {"item":"ParticipantInput_item__3rOBy","highlighted":"ParticipantInput_highlighted__LCDSd","details":"ParticipantInput_details__2klKW","name":"ParticipantInput_name__3awBe"};